import React from 'react';
import styled from 'styled-components';
import { ChartCard as SharedChartCard } from '../../components';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  children
}) => (
  <SharedChartCard title={title} subtitle={subtitle}>
    {children}
  </SharedChartCard>
);
